import { render, staticRenderFns } from "./RipaLocation.vue?vue&type=template&id=6d8167f2"
import script from "./RipaLocation.vue?vue&type=script&lang=js"
export * from "./RipaLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports